export default {
  state: {
    jobs: [],
    loading: false,
  },
  getters: {
    jobs: state => state.jobs,
    loading: state => state.loading,
  },
  mutations: {
    setJobs(state, jobs) {
      state.jobs = jobs;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const jobs = await axios.get('api/job-statuses');
        commit('setJobs', jobs);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, name) {
      return await axios.get(`api/jobs-statuses/${name}`);
    },
  },
};
